import { apiService, fetchingAPI } from '@/api'
import { toast } from '@/components/toasts/toast.helpers'
import { setData, setLoading } from '@/reducers/dataCleanup/dataCleanup.redux'

export const clearData = (body) => async (dispatch) => {
  dispatch(setLoading({ clearData: true }))
  try {
    await fetchingAPI(
      `${apiService.core}/api/organizations/clear_transcripts_and_audio`,
      'POST',
      dispatch,
      JSON.stringify(body)
    )
    toast.success('Successfully deleted data')
  } catch (error) {
    console.error('Error clearing data:', error)
    if (error?.status === 403 && error?.message) {
      const err = new Error(error.message)
      err.status = error.status
      throw err
    } else {
      toast.error(error?.message || 'An error occurred while clearing data')
      dispatch(setData({ modalOpen: false }))
    }
  } finally {
    dispatch(setLoading({ clearData: false }))
  }
}
export const fetchCallsForDataCleanup = (body) => async (dispatch) => {
  dispatch(setLoading({ calls: true }))
  try {
    const { calls } = await fetchingAPI(
      `${apiService.reporting}/api/calls`,
      'POST',
      dispatch,
      JSON.stringify(body)
    )
    dispatch(setData({ calls }))
  } catch (err) {
    dispatch(setData({ calls: [] }))

    toast.error('Failed to fetch calls', { cause: err })
  } finally {
    dispatch(setLoading({ calls: false }))
  }
}
